// extracted by mini-css-extract-plugin
module.exports = {"button":"NavbarComponent_button__1NXhp","icon":"NavbarComponent_icon__2QjTR"};